import { useEffect, useState } from 'react';

export default function SearchQuizCountdown({ endDate }) {
  const end = Date.parse(endDate);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!Number.isFinite(end) || end <= Date.now()) return undefined;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [end]);
  if (!Number.isFinite(end)) return null;
  const seconds = Math.max(0, Math.floor((end - now) / 1000));
  return <span className="recent" role="timer">{seconds > 0 ? `${Math.floor(seconds / 86400)}d ${String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0')}:${String(Math.floor(seconds % 3600 / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')} remaining` : 'Ended'}</span>;
}
